<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <div class="page-header">
        <div class="row align-items-center">
          <div class="col-sm-6 col-md-6">
            <h3 class="page-title">Bàn làm việc</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item"><a href="/">Dashboard</a></li>
              <li class="breadcrumb-item active">Bàn làm việc</li>
            </ul>
          </div>
          <div class="col-sm-6 col-md-6 float-right ml-auto">
            <button class="btn add-btn" @click="openAddModal">
              <i class="fa fa-plus"></i> Thêm mới
            </button>
          </div>
        </div>
      </div>
      <div class="card filter-card">
        <div
          class="card-header filter-card-header"
          data-toggle="collapse"
          href="#filter_inputs"
          role="button"
          aria-expanded="true"
          aria-controls="filter_inputs"
        >
          <h5 class="card-title mb-0">Bộ lọc dữ liệu</h5>
          <i class="fa fa-chevron-down collapse-icon"></i>
        </div>
        <div class="card-body card-body-filter collapse" id="filter_inputs">
          <div class="row filter-row">
            <div class="col-sm-6 col-md-4">
              <div class="form-group form-focus">
                <input
                  type="text"
                  class="form-control floating"
                  v-model="searchQuery"
                />
                <label class="focus-label">Tìm theo tên...</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-4">
              <div class="form-group form-focus select-focus">
                <vue-multiselect
                  v-model="selectedPhongBanFilter"
                  :options="phongBanOptions"
                  placeholder="Lọc theo phòng ban"
                  label="tenPhongBan"
                  track-by="idPhongBan"
                  :allow-empty="true"
                  deselect-label=""
                  select-label=""
                  selected-label=""
                >
                </vue-multiselect>
              </div>
            </div>
            <div class="col-6 col-sm-6 col-md-2">
              <button
                class="btn btn-success btn-block btn-sm"
                @click="applyFilters"
              >
                Tìm kiếm
              </button>
            </div>
            <div class="col-6 col-sm-6 col-md-2">
              <button
                class="btn btn-outline-secondary btn-block btn-sm"
                @click="resetFilters"
              >
                <i class="fa fa-refresh"></i> Làm mới
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="row staff-grid-row">
        <div
          v-for="ws in filteredWorkspaces"
          :key="ws.id"
          class="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 d-flex"
        >
          <div class="card workspace-widget">
            <img
              class="card-img-top workspace-cover"
              :src="ws.avatar"
              :alt="ws.avatar"
            />
            <span
              v-if="ws.unreadCount > 0"
              class="notification-badge"
              v-tooltip.top="`Có ${ws.unreadCount} thông báo mới`"
            >
              {{ ws.unreadCount > 99 ? "99+" : ws.unreadCount }}
            </span>
            <div class="dropdown profile-action">
              <a
                href="#"
                class="ropdown-toggle"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="material-icons">more_vert</i>
              </a>
              <div class="dropdown-menu dropdown-menu-right">
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="openEditModal(ws)"
                >
                  <i class="fa fa-pencil m-r-5"></i> Sửa
                </a>
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="openTemplateModal(ws)"
                >
                  <i class="fa fa-clone m-r-5"></i> Dùng làm mẫu
                </a>
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="handleWorkspaceDelete(ws)"
                >
                  <i class="fa fa-trash-o m-r-5"></i> Xóa
                </a>
              </div>
            </div>
            <div class="card-body">
              <h4 class="card-title text-ellipsis">
                <router-link
                  :to="`/bang-phan-chia-cong-viec/${ws.id}`"
                  v-tooltip="ws.tieuDe"
                >
                  {{ ws.tieuDe }}</router-link
                >
              </h4>
              <p
                class="card-text text-muted small workspace-description"
                v-tooltip="ws.moTa"
              >
                {{ ws.moTa }}
              </p>

              <div
                class="workspace-tags"
                v-if="ws.phongBans && ws.phongBans.length > 0"
              >
                <span
                  v-for="pb in ws.phongBans.slice(0, 2)"
                  :key="pb.idPhongBan"
                  class="badge badge-info"
                >
                  {{ pb.tenPhongBan }}
                </span>
                <span v-if="ws.phongBans.length > 2" class="badge badge-light">
                  +{{ ws.phongBans.length - 2 }}
                </span>
              </div>
              <!-- <div class="mt-3">
                <div class="d-flex justify-content-between">
                  <small>Tiến độ</small>
                  <small>{{ ws.progress }}%</small>
                </div>
                <div class="progress" style="height: 5px">
                  <div
                    class="progress-bar bg-success"
                    role="progressbar"
                    :style="{ width: ws.progress + '%' }"
                  ></div>
                </div>
              </div> -->

              <div
                class="d-flex justify-content-between align-items-center mt-3"
              >
                <div class="workspace-members">
                  <a href="#" class="avatar">
                    <img
                      :src="
                        ws.author.avatarUrl ??
                        'https://static.vecteezy.com/system/resources/thumbnails/027/951/137/small_2x/stylish-spectacles-guy-3d-avatar-character-illustrations-png.png'
                      "
                      v-tooltip="ws.author.hoTen"
                      :alt="ws.author.hoTen"
                    />
                  </a>
                  <template
                    v-if="
                      ws.managers.some(
                        (manager) =>
                          manager.idNguoiDung === ws.author.idNguoiDung
                      )
                    "
                  >
                    <a
                      v-if="ws.managers && ws.managers.length - 1 > 0"
                      href="#"
                      class="avatar"
                    >
                      <span
                        v-if="ws.managers.length - 1 > 0"
                        class="avatar-plus"
                      >
                        +{{ ws.managers.length - 1 }}
                      </span>
                    </a>
                  </template>

                  <template v-else>
                    <a
                      v-if="ws.managers && ws.managers.length > 0"
                      href="#"
                      class="avatar"
                    >
                      <span class="avatar-plus">
                        +{{ ws.managers.length }}
                      </span>
                    </a>
                  </template>
                </div>
                <small class="text-muted"
                  >Ngày tạo: {{ formatDate(ws.ngayTao) }}</small
                >
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 d-flex">
          <div class="create-new-card" @click="openAddModal">
            <div class="content">
              <i class="fa fa-plus"></i>
              <h4>Tạo mới</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="isAddModalVisible"
      class="modal custom-modal fade show"
      style="display: block; background-color: rgba(0, 0, 0, 0.5)"
      role="dialog"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Tạo không gian làm việc mới</h5>
            <button type="button" class="close" @click="closeModals">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="handleWorkspaceAdd">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      >Tên không gian làm việc
                      <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      type="text"
                      v-model="newWorkspace.tieuDe"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Mô tả</label>
                    <textarea
                      rows="4"
                      class="form-control"
                      v-model="newWorkspace.moTa"
                    ></textarea>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Thuộc về phòng ban (Tùy chọn)</label>
                    <vue-multiselect
                      v-model="newWorkspace.phongBans"
                      :options="phongBanOptions"
                      :multiple="true"
                      placeholder="Chọn phòng ban liên quan"
                      label="tenPhongBan"
                      track-by="idPhongBan"
                      deselect-label="Nhấn Enter để bỏ chọn"
                      select-label="Nhấn Enter để chọn"
                      selected-label="Đã chọn"
                    >
                    </vue-multiselect>
                  </div>
                </div>
              </div>
              <div class="submit-section">
                <button class="btn btn-primary submit-btn">Tạo mới</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="isEditModalVisible"
      class="modal custom-modal fade show"
      style="display: block; background-color: rgba(0, 0, 0, 0.5)"
      role="dialog"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Chỉnh sửa không gian làm việc</h5>
            <button type="button" class="close" @click="closeModals">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="handleWorkspaceUpdate">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      >Tên không gian làm việc
                      <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      type="text"
                      v-model="editableWorkspace.tieuDe"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Mô tả</label>
                    <textarea
                      rows="4"
                      class="form-control"
                      v-model="editableWorkspace.moTa"
                    ></textarea>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Thuộc về phòng ban (Tùy chọn)</label>
                    <vue-multiselect
                      v-model="editableWorkspace.phongBans"
                      :options="phongBanOptions"
                      :multiple="true"
                      placeholder="Chọn phòng ban liên quan"
                      label="tenPhongBan"
                      track-by="idPhongBan"
                      deselect-label="Nhấn Enter để bỏ chọn"
                      select-label="Nhấn Enter để chọn"
                      selected-label="Đã chọn"
                    >
                    </vue-multiselect>
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Người quản lý</label>
                    <vue-multiselect
                      v-model="editableWorkspace.managers"
                      :options="allUsers"
                      :multiple="true"
                      :close-on-select="false"
                      :clear-on-select="false"
                      placeholder="Chọn người quản lý"
                      label="hoTen"
                      track-by="idNguoiDung"
                      deselect-label="Nhấn Enter để bỏ chọn"
                      select-label="Nhấn Enter để chọn"
                      selected-label="Đã chọn"
                    >
                      <template #option="{ option }">
                        <span class="option__title">{{ option.hoTen }}</span>
                      </template>
                    </vue-multiselect>
                  </div>
                </div>
              </div>
              <div class="submit-section">
                <button class="btn btn-primary submit-btn">Lưu thay đổi</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="isTemplateModalVisible"
      class="modal custom-modal fade show"
      style="display: block; background-color: rgba(0, 0, 0, 0.5)"
      role="dialog"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Tạo mới từ mẫu:
              <span class="text-primary">"{{ sourceTemplate?.tieuDe }}"</span>
            </h5>
            <button type="button" class="close" @click="closeModals">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="handleWorkspaceCreateFromTemplate">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label
                      >Tên không gian làm việc mới
                      <span class="text-danger">*</span></label
                    >
                    <input
                      class="form-control"
                      type="text"
                      v-model="newWorkspaceFromTemplate.tieuDe"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Mô tả</label>
                    <textarea
                      rows="4"
                      class="form-control"
                      v-model="newWorkspaceFromTemplate.moTa"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="submit-section">
                <button class="btn btn-primary submit-btn">Tạo mới</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import Swal from "sweetalert2";
import { useToast } from "vue-toastification";
import workspaceService from "../services/workspaceService";
import userService from "../services/userService";
import phongBanService from "../services/phongBanService";

const toast = useToast();

// --- STATE MANAGEMENT ---
const workspaces = ref([]);
const allUsers = ref([]);
const searchQuery = ref("");
const phongBanOptions = ref([]);
const selectedPhongBanFilter = ref(null);

// Trạng thái điều khiển modals
const isAddModalVisible = ref(false);
const isEditModalVisible = ref(false);
const isTemplateModalVisible = ref(false);

// Biến lưu trữ dữ liệu cho các form
const newWorkspace = ref({ tieuDe: "", moTa: "", phongBans: [] });
const editableWorkspace = ref(null);
const sourceTemplate = ref(null);
const newWorkspaceFromTemplate = ref({ tieuDe: "", moTa: "" });

// --- LIFECYCLE HOOKS ---
onMounted(() => {
  fetchWorkspaces();
  fetchAllUsers();
  fetchPhongBanOptions();
});

// --- COMPUTED PROPERTIES ---
// Lọc danh sách workspace dựa trên ô tìm kiếm
const filteredWorkspaces = computed(() => {
  if (!searchQuery.value) {
    return workspaces.value;
  }
  return workspaces.value.filter((ws) =>
    ws.tieuDe.toLowerCase().includes(searchQuery.value.toLowerCase())
  );
});

// --- API METHODS ---
const fetchWorkspaces = async (phongBanId) => {
  try {
    // Truyền phongBanId (có thể là null) vào service
    const response = await workspaceService.getAll(phongBanId);
    workspaces.value = response.data;
  } catch (error) {
    console.error("Lỗi khi tải workspaces:", error);
    toast.error("Không thể tải danh sách không gian làm việc.");
  }
};

// Tải danh sách phòng ban
const fetchPhongBanOptions = async () => {
  try {
    const response = await phongBanService.getActiveOptions();
    phongBanOptions.value = response.data.data; // Giả sử API trả về { data: { data: [...] } }
  } catch (error) {
    console.error("Lỗi khi tải danh sách phòng ban:", error);
    toast.error("Không thể tải danh sách phòng ban.");
  }
};

// Xử lý nút Lọc
const applyFilters = () => {
  const pbId = selectedPhongBanFilter.value
    ? selectedPhongBanFilter.value.idPhongBan
    : null;
  fetchWorkspaces(pbId);
};

const resetFilters = () => {
  // 1. Đưa các biến filter về giá trị mặc định
  searchQuery.value = "";
  selectedPhongBanFilter.value = null;

  // 2. Tải lại danh sách (gọi hàm applyFilters để nó tự động fetch với pbId = null)
  applyFilters();
};

//Hàm lấy tất cả user
const fetchAllUsers = async () => {
  try {
    const response = await userService.getAll();
    allUsers.value = response.data.map((user) => ({
      idNguoiDung: user.idNguoiDung, // Chuyển idNguoiDung -> id
      hoTen: user.hoTen, // Chuyển tenDangNhap -> username
      avatarUrl: user.avatarUrl, // Giữ lại avatar nếu có
    }));
  } catch (error) {
    console.error("Lỗi khi tải danh sách người dùng:", error);
    // toast.error("Không thể tải danh sách người dùng.");
  }
};
// Đóng tất cả modals và reset state
const closeModals = () => {
  isAddModalVisible.value = false;
  isEditModalVisible.value = false;
  isTemplateModalVisible.value = false;

  newWorkspace.value = { tieuDe: "", moTa: "", phongBans: [] };
  editableWorkspace.value = null;
  sourceTemplate.value = null;
  newWorkspaceFromTemplate.value = { tieuDe: "", moTa: "" };
};

// Mở modal thêm
const openAddModal = () => {
  isAddModalVisible.value = true;
};

// Mở modal sửa
const openEditModal = (workspace) => {
  // Tạo một bản copy để chỉnh sửa không ảnh hưởng đến dữ liệu gốc
  editableWorkspace.value = {
    ...workspace,
    managers: workspace.managers ? [...workspace.managers] : [],
    phongBans: workspace.phongBans ? [...workspace.phongBans] : [],
  };
  isEditModalVisible.value = true;
};

const openTemplateModal = (workspace) => {
  sourceTemplate.value = workspace; // Lưu lại workspace nguồn
  isTemplateModalVisible.value = true;
};

// Xử lý logic nghiệp vụ
const handleWorkspaceAdd = async () => {
  try {
    const phongBanIds = newWorkspace.value.phongBans.map((pb) => pb.idPhongBan);
    // 3. Chuẩn bị payload khớp với WorkspaceDto
    const payload = {
      tieuDe: newWorkspace.value.tieuDe,
      moTa: newWorkspace.value.moTa,
      phongBanIds: phongBanIds,
    };
    await workspaceService.create(payload);
    toast.success("Thêm mới thành công!");
    await fetchWorkspaces();
    closeModals();
  } catch (error) {
    console.error("Lỗi khi tạo workspace:", error);
    toast.error(error?.response?.data?.message || "Tạo mới thất bại.");
  }
};

const handleWorkspaceUpdate = async () => {
  try {
    const phongBanIds = editableWorkspace.value.phongBans.map(
      (pb) => pb.idPhongBan
    );
    const managerIds = editableWorkspace.value.managers.map(
      (user) => user.idNguoiDung
    );
    const payload = {
      tieuDe: editableWorkspace.value.tieuDe,
      moTa: editableWorkspace.value.moTa,
      active: editableWorkspace.value.active,
      avatar: editableWorkspace.value.avatar,
      author: editableWorkspace.value.author,
      managerIds: managerIds,
      phongBanIds: phongBanIds,
    };
    await workspaceService.update(editableWorkspace.value.id, payload);
    toast.success("Cập nhật thành công!");
    await fetchWorkspaces(); // Tải lại danh sách
    closeModals();
  } catch (error) {
    console.error("Lỗi khi cập nhật workspace:", error);
    toast.error( error?.response?.data?.message ||"Cập nhật thất bại.");
  }
};

const handleWorkspaceDelete = async (deletableWorkspace) => {
  const result = await Swal.fire({
    title: `Bạn chắc chắn muốn xóa không gian "${deletableWorkspace.tieuDe}"?`,
    html: "Hành động này sẽ <strong>xóa vĩnh viễn</strong> và không thể hoàn tác. <br/>Bạn có muốn tiếp tục?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Xóa vĩnh viễn!",
    cancelButtonText: "Hủy bỏ",
  });
  if (result.isConfirmed) {
    try {
      await workspaceService.deleteById(deletableWorkspace.id);
      toast.success(`Đã xóa "${deletableWorkspace.tieuDe}" thành công!`);
      await fetchWorkspaces(); // Tải lại danh sách
      closeModals();
    } catch (error) {
      console.error("Lỗi khi xóa workspace:", error);
      toast.error(error?.response?.data?.message || "Xóa thất bại.");
    }
  }
};

const handleWorkspaceCreateFromTemplate = async () => {
  if (!sourceTemplate.value) return;
  try {
    const payload = {
      tieuDe: newWorkspaceFromTemplate.value.tieuDe,
      moTa: newWorkspaceFromTemplate.value.moTa,
    };

    await workspaceService.createFromTemplate(sourceTemplate.value.id, payload);
    toast.success(
      `Đã tạo không gian làm việc mới từ mẫu "${sourceTemplate.value.tieuDe}"!`
    );
    await fetchWorkspaces();
    closeModals();
  } catch (error) {
    console.error("Lỗi khi tạo từ mẫu:", error);
    toast.error("Tạo từ mẫu thất bại.");
  }
};

// Hàm để format ngày tháng
const formatDate = (isoString) => {
  if (!isoString) return ""; // Trả về rỗng nếu ngày không tồn tại
  const date = new Date(isoString);
  // 'vi-VN' sẽ format theo chuẩn dd/mm/yyyy
  return date.toLocaleDateString("vi-VN");
};
</script>

<style scoped>
/* Scoped CSS để không ảnh hưởng đến các component khác */
.workspace-widget {
  width: 100%;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  margin-bottom: 30px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}
/* .workspace-widget:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transform: translateY(-5px);
} */
.workspace-cover {
  height: 120px;
  object-fit: cover;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.card-body {
  flex-grow: 1;
  position: relative;
}
.profile-action {
  position: absolute;
  top: 10px;
  right: 15px;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.workspace-description {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-clamp: 2;
}
.workspace-members .avatar {
  width: 30px;
  height: 30px;
  border: 2px solid #fff;
  border-radius: 50%;
  margin-left: -10px;
  position: relative;
  display: inline-block;
}
.avatar > img {
  height: 100%;
}
.workspace-members .avatar:first-child {
  margin-left: 0;
}
.workspace-members .avatar-plus {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #f0f0f0;
  color: #333;
  font-size: 0.75rem;
  font-weight: bold;
}

.create-new-card {
  width: 100%;
  background-color: #f8f9fa;
  border: 1px dashed #dee2e6;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #6c757d;
  min-height: 250px;
  margin-bottom: 30px;
  flex-direction: column;
}
.create-new-card:hover {
  background-color: #e9ecef;
  border-color: #007bff;
  color: #007bff;
}
.create-new-card .content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.create-new-card .content .fa {
  font-size: 2rem;
}
/* CSS CHO TAG PHÒNG BAN */
.workspace-tags {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
.workspace-tags .badge {
  font-size: 11px;
  font-weight: 500;
  padding: 4px 8px;
}
/* chỉnh phần model */
.modal-content {
  overflow: auto;
  height: 95vh;
}
/* Filter Card Styles */
.filter-card-header {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
}
.card-body-filter {
  border-top: 1px solid #dee2e6;
}
.filter-card-header .collapse-icon {
  transition: transform 0.3s ease;
}
.filter-card-header[aria-expanded="false"] .collapse-icon {
  transform: rotate(-90deg);
}
.filter-card .form-group {
  margin-bottom: 1rem; /* Consistent spacing */
}
label {
  font-weight: 500;
}
.form-focus .form-control {
  height: 43px;
  padding: 0;
}
.filter-row .btn {
  min-height: 42px;
}
/* (CSS CHO BADGE) ===== */
/* ============================================== */
.notification-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: #ff0000; /* Màu đỏ nổi bật */
  color: white;
  width: 28px; /* Kích thước cố định */
  height: 28px;
  border-radius: 50%; /* Bo tròn */
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: bold;
  z-index: 10; /* Nằm trên ảnh */
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

  /* Áp dụng hiệu ứng */
  animation: pulse-animation 2s infinite;
}

/* Định nghĩa hiệu ứng nhấp nháy (pulse) */
@keyframes pulse-animation {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgb(255, 0, 0);
  }
  70% {
    transform: scale(1.1); /* Hơi phồng lên */
    box-shadow: 0 0 0 10px rgba(255, 1, 1, 0); /* Tỏa sáng */
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 47, 47, 0);
  }
}
</style>
